export default __webpack_public_path__ + "static/media/slideofertas-01.3f7541b7.jpg";